import clsx from "clsx";
import type { ButtonProps } from "./types";

const variantClasses: Record<string, string> = {
  default: "bg-gray-100 text-gray-700 hover:bg-gray-200",
  primary: "bg-blue-600 text-white hover:bg-blue-700",
  danger: "bg-red-600 text-white hover:bg-red-700",
  success: "bg-green-600 text-white hover:bg-green-700",
  warning: "bg-amber-50 text-amber-700 hover:bg-amber-100",
  text: "text-blue-600 hover:text-blue-700",
  outline:
    "text-gray-600 hover:text-blue-600 border border-gray-300 hover:border-blue-400",
  inverted: "bg-white text-indigo-700 hover:bg-indigo-50",
};

const sizeClasses: Record<string, string> = {
  sm: "px-3 py-1.5 text-xs",
  md: "px-3 py-2 text-sm",
  lg: "px-4 py-2.5 text-sm",
};

export const Button = ({
  variant = "default",
  size = "md",
  type = "button",
  className,
  children,
  startAdornment,
  endAdornment,
  ...rest
}: ButtonProps) => (
  <button
    type={type}
    className={clsx(
      "rounded-lg font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed",
      "flex items-center justify-center gap-1",
      variantClasses[variant],
      sizeClasses[size],
      className,
    )}
    {...rest}
  >
    {startAdornment}
    {children}
    {endAdornment}
  </button>
);
